import React, {useEffect, useRef, useState} from 'react';
import {Box, Button, Stack, Text} from '@chakra-ui/react';
import All from './Podcasts/all';
import Healthcare from "./Podcasts/healthcare";
import Technology from "./Podcasts/technology";
import News from './Podcasts/news';
import axios from "axios";
import MenuKit from '../../../components/kits/Menu';
import {useParams, useSearchParams, useLocation, useNavigate} from "react-router-dom";
import Container from "../../../components/Container";

const Podcasts = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [filter, setFilter] = useState('all');
    const [insightsInvestors, setInsightsInvestors] = useState(undefined)
    const [investOption, setInvestOption] = useState(null);
    const [activeInvestor, setActiveInvestor] = useState(undefined)
    const containerRef = useRef()
    const {pageCount} = useParams();
    const [startIndex, setStartIndex] = useState(pageCount || 0)
    const {state: pageState} = useLocation();
    const navigate = useNavigate();

    const scrollToTop = () => {
        // console.log('filters', filters);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        const abortController = new AbortController();
        const fetchInsightsData = async () => {
            const investors = await axios.get(`/wp-admin/admin-ajax.php?action=get_insights_authors`, {signal: abortController.signal}).then(resp => {
                return resp.data;
            });
            setInsightsInvestors(investors)
        }
        fetchInsightsData()
        return () => {
            abortController.abort();
        }
    }, [])

    useEffect(() => {
        if(pageState?.comingFrom == 'footer' || pageState?.comingFrom == 'header') {
            scrollToTop();
        }
    }, [pageState])

    const aInvestor = searchParams.get('investor') ?? undefined;

    useEffect(() => {
        if (aInvestor) {
            setActiveInvestor(aInvestor)
            const d = insightsInvestors?.find((i) => i?.post_name === aInvestor)
            setInvestOption({
                title: d?.post_title,
                value: d?.post_name
            })
        }
    }, [aInvestor, insightsInvestors])

    const options = React.useMemo(
        () =>
            insightsInvestors?.map((item) => {
                const el = {
                    title: item.post_title,
                    value: item.post_name,
                };

                return {
                    ...el,
                    onClick: () => {
                        // setFilter('all')
                        setFilter(undefined)
                        setSearchParams({investor: el?.value})
                        setInvestOption(el)
                        setActiveInvestor(el?.value)
                        setStartIndex(0)
                        navigate(`/insights/?investor=${el?.value}`)
                    },
                };
            }),
        [insightsInvestors, setSearchParams],
    );
    /*
        former mobile filter
        <Box pb={'29px'} display={{base: 'flex', md: 'none'}}>
                                        <Button
                                            p={'15px !important'}
                                            fontSize={'8px'}
                                            lineHeight={'8px'}
                                            isActive={filter === null}
                                        >
                                            Filter: All
                                        </Button>
                                    </Box>
    */
    return (
        <Box borderX={'1px'} borderColor={'brandAlpha.200'} as="section">
            <Box px={['2.5', '5']}>
                <Container>
                    <Stack
                        spacing="16"
                        height={'100%'}
                        alignSelf={'stretch'}
                        direction={{base: 'column', md: 'row'}}
                        ref={containerRef}
                    >
                        <Text
                            pb={'40px'}
                            as={'h1'}
                            lineHeight={{base: '18px', md: '2rem'}}
                            textAlign={'left'}
                            fontSize={{base: '18px', md: '2rem'}}
                            width={{base: 'full', md: '75%'}}
                        >
                            Insights
                        </Text>
                        <Text
                            pb={'40px'}
                            as={'h1'}
                            lineHeight={{base: '18px', md: '2rem'}}
                            textAlign={'left'}
                            fontSize={{base: '18px', md: '2rem'}}
                            width={{base: 'full', md: '25%'}}
                            display={{base: 'none', md: 'flex'}}
                        >
                            News
                        </Text>
                    </Stack>
                    <Box textAlign={'left'}>
                        <Box pb={'120px'}>
                            <Stack
                                spacing="16"
                                height={'100%'}
                                alignSelf={'stretch'}
                                direction={{base: 'column', md: 'row'}}
                            >
                                <Box alignSelf={'stretch'} maxW={{base: 'full', md: '75%'}} height={'100%'}
                                     id="filters">
                                    
                                    <Box display={{base: 'flex', md: 'flex'}} flexWrap={'wrap'} pb={'50px'}
                                        borderRight={{base: 'none', md: '1px solid #A1B6E5'}}
                                        >
                                        <Button onClick={() => {
                                            searchParams.delete('investor')
                                            setSearchParams(searchParams);
                                            setFilter('all')
                                            setActiveInvestor(undefined)
                                            setInvestOption(null)
                                        }}
                                                isActive={(!investOption && filter === 'all')}>All</Button>
                                        <Button 
                                            display={{base: 'none', md: 'inline'}}
                                            onClick={() => {
                                            searchParams.delete('investor')
                                            setSearchParams(searchParams);
                                            setInvestOption(null)
                                            setFilter('healthcare')
                                        }}
                                                isActive={filter === 'healthcare'}>Healthcare</Button>
                                        <Button 
                                            display={{base: 'none', md: 'inline'}}
                                            onClick={() => {
                                            searchParams.delete('investor')
                                            setSearchParams(searchParams);
                                            setInvestOption(null)
                                            setFilter('technology')
                                        }}
                                                isActive={filter === 'technology'}>Technology</Button>
                                        <MenuKit
                                            gutter={20}
                                            buttonProps={{
                                                children: !!investOption ? investOption?.title : 'Investor',
                                                isActive: !!investOption,
                                            }}
                                            activeItem={investOption?.value}
                                            options={options}
                                        />
                                    </Box>
                                    {(filter === 'all' || activeInvestor)&& <All containerRef={containerRef} startIndex={startIndex} activeInvestor={activeInvestor}
                                                              setStartIndex={setStartIndex}/>}
                                    {filter === 'healthcare' &&
                                        <Healthcare containerRef={containerRef} startIndex={startIndex}
                                                    setStartIndex={setStartIndex}/>}
                                    {filter === 'technology' &&
                                        <Technology containerRef={containerRef} startIndex={startIndex}
                                                    setStartIndex={setStartIndex}/>}
                                </Box>
                                <Box
                                    alignSelf={'stretch'}
                                    marginLeft={{base: 'none', md: 'auto !important'}}
                                    width={{base: 'full', md: '410px'}}
                                    height={'100%'}
                                >
                                    <News/>
                                </Box>
                            </Stack>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};
export default Podcasts;
